"use client";

import React from "react";
import { MapPin, Phone, Mail, Clock, ShieldCheck, Award, ThumbsUp } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="227362" className="flex flex-col gap-3">
        {[1, 2, 3, 4, 5].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-sidebar-accent/50 animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sidebar-foreground/70 hover:text-primary transition-all duration-300 text-sm">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
const contactDetails = [];
const trustBadges = [{
  id: "license",
  icon: ShieldCheck,
  text: "VCA Gecertificeerde Projecten"
}, {
  id: "award",
  icon: Award,
  text: "Nr. 1 Partner voor ZZP'ers"
}, {
  id: "satisfaction",
  icon: ThumbsUp,
  text: "98% Tevreden Installateurs"
}];
const legalLinks = [{
  id: "license",
  label: "Algemene Voorwaarden",
  href: "#"
}, {
  id: "promise",
  label: "Garantie & Service",
  href: "#"
}, {
  id: "privacy",
  label: "Privacybeleid",
  href: "#"
}];
export default function FooterInformation() {
  return <footer id="footer" className="bg-sidebar text-sidebar-foreground pt-16 pb-8 border-t border-sidebar-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          
          {}
          <div className="flex flex-col gap-6">
            <Link to="/" className="inline-block w-fit">
              <img src="/img/cl_installaties_logo_light.png" alt="CL Installaties" className="h-7 w-auto object-contain brightness-0 invert" />
            </Link>
            <p className="text-sidebar-foreground/70 text-sm font-default leading-relaxed">CL Installaties is de drijvende kracht achter de energietransitie. Als gespecialiseerde onderaannemer bieden wij ZZP'ers continuïteit in projecten voor zonnepanelen, thuisbatterijen en warmtepompen.</p>
          </div>

          {}
          <div>
            
            <MenuProvider menu_id="3">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            
            <ul className="flex flex-col gap-4">
              {contactDetails.map((item, i) => {
              const Icon = item.icon;
              return <li key={item.id} data-index={i} className="flex items-start gap-3 text-sidebar-foreground/70 text-sm group cursor-pointer">
                    <Icon className="size-5 shrink-0 text-primary group-hover:text-primary/80 transition-colors" />
                    
                  </li>;
            })}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-lg mb-6 tracking-tight text-sidebar-foreground">Word Partner</h3>
            <div className="flex flex-col gap-6">
              <div className="flex items-center gap-4 bg-sidebar-accent/30 p-3 rounded-lg border border-sidebar-border">
                <div className="bg-sidebar-accent p-2 rounded-md shrink-0 shadow-sm">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642666/img/wechat_qr_code_footer.png" alt="Scan voor klussen" className="size-16 object-cover rounded-sm grayscale brightness-125" />
                </div>
                <div className="text-sm text-sidebar-foreground/70">
                  <p className="font-bold text-sidebar-foreground mb-1 font-default">Nieuwe Klussen Alert</p>
                  <p className="text-xs leading-snug">Scan voor directe meldingen van projecten bij jou in de regio.</p>
                </div>
              </div>
              
              <ul className="flex flex-col gap-3">
                {trustBadges.map((badge, i) => {
                const Icon = badge.icon;
                return <li key={badge.id} data-index={i} className="flex items-center gap-2 text-sidebar-foreground/80 text-sm">
                      <Icon className="size-4 text-primary" />
                      <span className="font-default">{badge.text}</span>
                    </li>;
              })}
              </ul>
            </div>
          </div>
        </div>

        <Separator className="bg-sidebar-border/50 mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs font-default text-sidebar-foreground/50 tracking-wide">
          <p>© 2026 CL Installaties. Alle rechten voorbehouden.</p>
          <ul className="flex flex-wrap items-center gap-4 md:gap-6">
            {legalLinks.map((link, i) => <li key={link.id} data-index={i}>
                <Link to={link.href} className="hover:text-primary transition-colors uppercase">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </div>
      </div>
    </footer>;
}